export const State1 = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="12" height="12" fill="white" fillOpacity="0.01" />
    <rect
      width="10"
      height="10"
      transform="translate(1 1)"
      fill="white"
      fillOpacity="0.01"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.00002 1.71721C3.63469 1.71721 1.71722 3.63469 1.71722 6.00001C1.71722 8.36532 3.63469 10.2828 6.00002 10.2828C8.36532 10.2828 10.2828 8.36532 10.2828 6.00001C10.2828 3.63469 8.36532 1.71721 6.00002 1.71721ZM7.77696 4.75708C7.92434 4.60967 7.92434 4.37066 7.77696 4.22324C7.62954 4.07583 7.39053 4.07583 7.24311 4.22324L6.0001 5.46625L4.75709 4.22324C4.60968 4.07583 4.37066 4.07583 4.22325 4.22324C4.07583 4.37066 4.07583 4.60967 4.22325 4.75708L5.46626 6.00009L4.22325 7.2431C4.07583 7.39051 4.07583 7.62953 4.22325 7.77694C4.37066 7.92435 4.60968 7.92435 4.75709 7.77694L6.0001 6.53393L7.24311 7.77694C7.39053 7.92435 7.62954 7.92435 7.77696 7.77694C7.92434 7.62953 7.92434 7.39051 7.77696 7.2431L6.53394 6.00009L7.77696 4.75708Z"
      fill="#CE2C31"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.00002 1C3.23858 1 1 3.23858 1 6.00001C1 8.76138 3.23858 11 6.00002 11C8.76145 11 11 8.76138 11 6.00001C11 3.23858 8.76145 1 6.00002 1ZM1.71722 6.00001C1.71722 3.63469 3.63469 1.71721 6.00002 1.71721C8.36532 1.71721 10.2828 3.63469 10.2828 6.00001C10.2828 8.36532 8.36532 10.2828 6.00002 10.2828C3.63469 10.2828 1.71722 8.36532 1.71722 6.00001Z"
      fill="#CE2C31"
    />
  </svg>
);
